export default __webpack_public_path__ + "7bf573c5892cfa0e7c27a5c3d91702b1.png";